import { useLanguage } from 'features/hooks/useLanguage';
import { LanguageType } from 'types';

export const SearchCodelistSection = () => {
	const language = useLanguage();
	const translation = DICTIONARY[language];

	return (
		<div className="flex flex-col gap-4">
			<p className="text-base">{translation.description}</p>

			<img
				className="mt-6 w-[90%] object-cover self-center"
				src="/img/codelist-changelog/search.gif"
				alt={translation.imgAlt}
			/>
		</div>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		description:
			'You may find entries based on personal identifiable information. Click the row to go directly to the entry.',
		imgAlt: 'A gif showing how to find an entry based on personal identifiable information'
	},

	[LanguageType.Norwegian]: {
		description:
			'Dersom du vil finne en oppføring basert på personlig identifiserbar informasjon kan du søke i kodelistene. Trykk på raden for å gå direkte til oppføringen.',
		imgAlt: 'En gif som viser hvordan man finner oppføringer basert på personlig identifiserbar informasjon'
	}
};
